import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { PROFFIT_SEARCH_LANDING_PAGE_KEY_VISUAL_MAIN_IMAGE_URL } from '../../../../../define/consts/assets';
import { propBool, propFunc, propStr, } from '../../../../../helpers/custom-prop-types';
import Image from '../../../../Ui/Common/Image';
import ProffitSearchLandingPageKeyVisualCta from './ProffitSearchLandingPageKeyVisualCta';
const ProffitSearchLandingPageKeyVisualRight = (props) => {
    const { isEndTrial, plan, showFormModal } = props;
    return (_jsxs("div", Object.assign({ className: 'proffit_search_landing_page_key_visual_right' }, { children: [_jsx("div", Object.assign({ className: 'right_image' }, { children: _jsx(Image, { alt: 'PROFFIT SEARCH', className: 'image_thumbnail', src: PROFFIT_SEARCH_LANDING_PAGE_KEY_VISUAL_MAIN_IMAGE_URL, useImage: true }) })), _jsx(ProffitSearchLandingPageKeyVisualCta, { className: 'right_description', isEndTrial: isEndTrial, plan: plan, showFormModal: showFormModal })] })));
};
ProffitSearchLandingPageKeyVisualRight.propTypes = {
    isEndTrial: propBool().isRequired,
    plan: propStr(),
    showFormModal: propFunc().isRequired,
};
ProffitSearchLandingPageKeyVisualRight.defaultProps = {
    plan: undefined,
};
export default ProffitSearchLandingPageKeyVisualRight;
